import React, { useCallback, useEffect, useState } from 'react';
import classNames from 'classnames';
import { useRouter } from 'next/router';

import { PATH } from 'common/constants';
import { NotStartedBanner } from './NotStartedBanner';
import { InProgressBanner } from './InProgressBanner';
import cn from './styles.module.scss';
import { SurveySeason, SurveySeasonService } from 'types';
import { showNotification } from 'common/function';
import { isApiError } from 'common/types';
import { reportError } from 'utils/reporting';

export { SurveySeasonBadge } from './SurveySeasonBadge';
export { SurveySeasonIllustration } from './SurveySeasonIllustration';

export function SurveySeasonBanner() {
  const router = useRouter();
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [surveySeason, setSurveySeason] = useState<SurveySeason | undefined>()

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      try {
        setSurveySeason((await SurveySeasonService.getSurveySeason()));
      } catch (e) {
        // 404 means no survey season exists yet for this tenant — the expected
        // "not started" state, so surveySeason stays undefined and NotStartedBanner renders.
        if (!isApiError(e) || e.status !== 404) {
          reportError(e);
          showNotification(
            isApiError(e) ? e.message : 'Something went wrong',
            'Failed to load survey season',
            'error',
          )
        }
      }
      setIsLoading(false);
    })();
  }, [])

  const onAction = useCallback(() => {
    router.push(PATH.SURVEY_RESULTS_SEASON);
  }, [router]);

  if (isLoading) {
    return null;
  }

  return (
    <div
      className={classNames(cn.banner, surveySeason && cn.bannerCompact)}
      data-testid="surveySeasonBanner"
    >
      {surveySeason ? (
        <InProgressBanner surveySeason={surveySeason} onContinue={onAction} />
      ) : (
        <NotStartedBanner onGetStarted={onAction} />
      )}
    </div>
  );
}
